/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 25.08.2016.
 */

import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Link} from 'react-router';
import {VelocityTransitionGroup} from 'velocity-react';

import Translate from '../../Translate';

import {FetchAssetById} from '../../../actions/asset/action-asset';

import moment from 'moment';

import _get from 'lodash/get';
import _find from 'lodash/find';

class NotificationMessage extends Component {
  constructor(props) {
    super(props);

    this.animationEnterTop = {
      translateY: '0px',
      opacity: 1
    };

    this.animationLeaveTop = {
      translateY: '-100px',
      opacity: 0
    };

    this.animationEnterBottom = {
      translateY: '0px',
      opacity: 1
    };

    this.animationLeaveBottom = {
      translateY: '100px',
      opacity: 0
    };

    this.state = {
      channelLogo: null,
      eventPicture: null,
      isShown: false
    };
  }

  componentDidMount() {

    if (this.props.notification) this.props.FetchAssetById(this.props.notification.channelId);

    this.setState({
      isShown: this.props.isShown
    });

    this._getMetadata();
  }

  componentWillReceiveProps(newProps) {

    this.setState({
      isShown: newProps.isShown
    });

    this._getMetadata(newProps);
  }

  _getMetadata(props = this.props) {

    if (props.channel.id) {

      lh.models.channelAsset.methods.getPosterUrl(props.channel, {
        crop: {x: 50, y: 50},
        cache: false
      })
        .then((url) => {

          this.setState({
            channelLogo: url
          })
        }, ()=> {
        });
    }

    if (props.event) {

      lh.models.epgEvent.methods
        .getPosterUrl(props.event.program, {
          crop: {x: 198, y: 173},
          cache: false
        })
        .then((url) => {
          this.setState({eventPicture: url});
        }, () => {
          this.setState({eventPicture: `/images/${Config.white_skin ? 'white' : 'black'}/white-full.png`});
        });
    }
  }

  _onCrossClick() {

    this.setState({
      isShown: false
    });

    this.props.onClose();
  }

  _renderTime() {
    let start =  moment.unix(_get(this.props, 'event.start'));

    return (
        <span>{start.format(_get(Config, 'epg.epg_event_time_format', 'HH:mm'))} </span>
    );
  }

  render() {

    return (
      <div>
        {this.state.isShown && <a className="mw-close ico ico-close slider-resume" href="javascript:void(0)" onClick={this._onCrossClick.bind(this)}></a>}
        {this.state.isShown && <div>
          <div className="popup-block remind">
            <VelocityTransitionGroup
              runOnMount={true}
              enter={{animation: this.animationEnterTop, easing: 'ease-in-out', duration: 350}}
              leave={{animation: this.animationLeaveTop, easing: 'ease-in-out', duration: 150}}>
              <div className="img-container animate-shake">
                <img className="remind-img" src={`/images/${Config.white_skin ? 'white' : 'black'}/remind_big.png`} />
                <img className="event-img" src={this.state.eventPicture} />
              </div>
            </VelocityTransitionGroup>
            <VelocityTransitionGroup
              runOnMount={true}
              enter={{animation: this.animationEnterBottom, easing: 'ease-in-out', duration: 350}}
              leave={{animation: this.animationLeaveBottom, easing: 'ease-in-out', duration: 150}}>
              <div>
                <p>
                  <strong> <Translate content="messages.notification.title" /> {this._renderTime()} </strong>
                  <div className="clearfix">
                    <div style={{float: 'left'}}>
                      {this.state.channelLogo && <img src={this.state.channelLogo} /> }
                      <span> {_get(this.props, 'channel.title')} </span>
                    </div>
                  </div>
                  <div className="pt">
                    <em style={{fontWeight: 'bold'}}>{_get(this.props, 'event.title')}</em> <Translate content="messages.notification.is_switch_show_right_now" />
                  </div>
                </p>
              </div>
              <div className="mt+ message-actions">
                <Link to={'/epg/' + _get(this.props, 'event.channel_id') + '?e=' + _get(this.props, 'event.program.id') + '&start=' + _get(this.props, 'event.start')} className="btn-dark-popup yes" onClick={this._onCrossClick.bind(this)}> <Translate content="yes" /> </Link>
                <a className="btn-dark-popup no" href="javascript:void(0)" onClick={this._onCrossClick.bind(this)}> <Translate content="no_thanks" /> </a>
              </div>
            </VelocityTransitionGroup>
          </div>
        </div>}
      </div>
    );
  }
}

NotificationMessage.propTypes = {
  message: PropTypes.shape({
    type: PropTypes.string.isRequired,
    notification_id: PropTypes.number.isRequired
  }),
  onClose: PropTypes.func.isRequired,
  isShown: PropTypes.bool.isRequired
};

const mapStateToProps = ({assets, notifications}, ownProps) => {
  let notification = _find(_get(notifications, 'notifications.collection'), {id: _get(ownProps.message, 'notification_id')});
  let channel = _get(assets, _get(notification, 'channel_id'), {});

  return {
    event: notification,
    channel: channel
  };
};

const mapDispatchToProps = (dispatch) => {

  return bindActionCreators({FetchAssetById}, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationMessage);



// WEBPACK FOOTER //
// ./src/components/ModalWindow/Notification/notification-message.js